(function ($) {

    var delayTimer;
    var entities = { result: [], totalMatching: 0 };
    var map;
    var markers;

    var source = $("#entity-template").html();
    var template = Handlebars.compile(source);
    var districts = [];
    var ownertypes = [];
    var query = "";

    map = initializeMap("entities-map", 58.97, 5.74, 12);

    // Use received data to bind to view
    function entityShowResult(data) {
        entities.Items = data.Items;
        if (map == null)
            return;

        if (markers != null)
            map.removeLayer(markers);

        markers = L.markerClusterGroup();
        markers.clearLayers();

        const markerIcon = L.icon({
            // specify the path here
            iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
            shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
            // Uten disse setter Leaflet ingen margin, og ikonets øverste venstre hjørne
            // havner på koordinatet i stedet for nålespissen. Samme mål som standardikonet
            // map.js bruker på entitetssidene.
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        $(entities.Items).each(function (index, item) {

            // Uten koordinater ville markøren havnet på 0,0, utenfor Afrika
            if (!item.Latitude || !item.Longitude) {
                return;
            }

            // create the marker
            var marker = L.marker([item.Latitude, item.Longitude], { icon: markerIcon });
            marker.bindPopup('' +
                '<strong><a href="' + item.Url + '">' + item.Name + '</a></strong><br />' +
                '<a href="https://maps.google.com/?daddr=' + item.Latitude + ',' + item.Longitude + '" target="_new" class="external">Se veibeskrivelse</a>'
            );
            markers.addLayer(marker);
        });
        map.addLayer(markers);
        // Treff uten koordinater gir ingen markør, og tomme bounds får Leaflet til å kaste.
        if (markers.getLayers().length) {
            map.fitBounds(markers.getBounds(), { padding: [20, 20] });
        }

        entities.TotalMatching = data.TotalMatching;
        var html = template(entities);
        $("#entities-result").html(html);
    }

    // Search for string and handle received data
    function entitySearch(query, filters) {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {

            // Update url with query
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + query;

                // Add ownertype selection
                if (filters.ownertypes.length)
                    newurl = newurl + "&o=" + filters.ownertypes;

                // Add districts selection
                if (filters.districts.length)
                    newurl = newurl + "&d=" + filters.districts;

                window.history.pushState({ path: newurl }, '', newurl);
            }

            $.getJSON(entityApiUrl, { query: query, districts: filters.districts, ownertypes: filters.ownertypes }, entityShowResult);
        }, 250);
    }

    // Handle search input text input
    var entitySearchInputTimer;
    $('#search-entity-form .entity-search-input').on('input', function () {
        query = $(this).val();

        var filters = {
            districts: districts.join(),
            ownertypes: ownertypes.join()
        }
        entitySearch(query, filters);
    });

    // Trigger input event if value is present
    if ($('#search-entity-form .entity-search-input').val() !== '') {
        $("#search-entity-form .entity-search-input").trigger("input");
    }

    // Handle button search
    $('#search-entity-form input[type=submit]').click(function (e) {
        var val = $(this).siblings(".entity-search-input").val();
        query = val;

        var filters = {
            districts: districts.join(),
            ownertypes: ownertypes.join()
        }
        entitySearch(query, filters);
    });

    $(".filter-district input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            districts.push($(this).val());
        } else {
            var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                districts.splice(index, 1);
            }
        }

        var filters = {
            districts: districts.join(),
            ownertypes: ownertypes.join()
        }
        entitySearch(query, filters);
    });

    $(".filter-ownertype input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            ownertypes.push($(this).val());
        } else {
            var index = ownertypes.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                ownertypes.splice(index, 1);
            }
        }

        var filters = {
            districts: districts.join(),
            ownertypes: ownertypes.join()
        }
        entitySearch(query, filters);
    });

    // Search for blank on start
    $(document).ready(function () {

        $('.filter-district input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                districts.push($(this).val());
            } else {
                var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    districts.splice(index, 1);
                }
            }
        });

        $('.filter-ownertypes input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                ownertypes.push($(this).val());
            } else {
                var index = ownertypes.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    ownertypes.splice(index, 1);
                }
            }
        });

        var filters = {
            districts: districts.join(),
            ownertypes: ownertypes.join()
        }
        entitySearch(query, filters);
    });

})(jQuery);
